import { render, staticRenderFns } from "./AssessmentCheckPayment.vue?vue&type=template&id=4b489cb8&scoped=true"
import script from "./AssessmentCheckPayment.vue?vue&type=script&lang=js"
export * from "./AssessmentCheckPayment.vue?vue&type=script&lang=js"
import style0 from "./AssessmentCheckPayment.vue?vue&type=style&index=0&id=4b489cb8&prod&scoped=true&lang=css"
import style1 from "./AssessmentCheckPayment.vue?vue&type=style&index=1&id=4b489cb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b489cb8",
  null
  
)

export default component.exports